<template>
    <el-dialog :visible.sync="visible"
        :title="$t('privateNetInstance.bindTitle')"
        :close-on-click-modal="false"
        :before-close="handleClose" class="bind-dialog">
        <el-alert :title="$t('privateNetInstance.chooseBindTip', [instanceName])"
            type="info"
            :closable="false">
        </el-alert>
        <el-form ref="form">
            <el-form-item>
                <el-table :data="flexPublicNetList"
                    style="width: 100%;"
                    @selection-change="optionalSelectionChange"
                    max-height="242"
                    class="bind-flex-net">
                    <el-table-column type="selection" :selectable="selectable">
                    </el-table-column>
                    <el-table-column prop="elasticIp"
                        :label="$t('privateNetInstance.tableTitle.ip')">
                        <template slot-scope="scope">
                          <span>{{ scope.row.elasticIp }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bandwidth"
                        :label="$t('privateNetInstance.tableTitle.bandWidth')">
                        <template slot-scope="scope">
                          <span>{{ scope.row.bandwidth.toString() | withColon('Mbps') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="region"
                        :label="$t('privateNetInstance.tableTitle.region')">
                        <template slot-scope="scope">
                          <span>{{ $t('eip.text.allAz') }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <span>{{$t('nat.speechCraft.bindEipCount1')}}</span>
                <span class="highlight-font-color">{{((20-rowInfo.eipNum)-currentAddList.length)}}</span>
                <span>{{$t('nat.speechCraft.bindEipCount2')}}</span>
                <span v-if="currentHover">{{$t('nat.speechCraft.natlimit')}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="cancelBind">
                {{ $t('privateNetInstance.cancel') }}
            </el-button>
            <el-button @click="sureBind"
                type="primary"
                :disabled="currentAddList.length === 0 || loading"
                :loading="loading">
                {{ $t('privateNetInstance.bindSure') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
  name: 'BindFlexNet',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    instanceName: {
      type: String,
      default: ''
    },
    region: {
      type: String,
      default: ''
    },
    instanceId: {
      type: String,
      default: ''
    },
    rowInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      form: {
      },
      flexPublicNetList: [],
      // 当前选中态的即将添加的实例
      currentAddList: [],
      currentEipIdList: [],
      currentHover: false,
      subnetId: this.rowInfo.subnetId, // 主网口或辅网口子网id
      pageSize: 10,
      remainCount: 0,
      loading: false, // 添加loading状态
    };
  },
  computed: {

  },
  watch: {
  },
  created() {
    this.getFlexPublicNetList();
  },
  methods: {
    selectable(row) {
      let selected = true;
      if (this.currentAddList.length >= (20 - this.rowInfo.eipNum)) {
        if (row.flag) {
          selected = true;
        } else {
          selected = false;
        }
      } else {
        selected = true;
      }
      return selected;
    },

    handleClose() {
      this.$emit('update:visible', false);
    },
    cancelBind() {
      this.handleClose();
    },
    sureBind() {
      // 防止重复点击
      if (this.loading) return;
      
      this.loading = true;
      
      const params = {
        region: this.rowInfo.region,
        az: this.rowInfo.az,
        clientToken: this.clientToken,
        natGatewayId: this.rowInfo.natGatewayId,
        eipIds: this.currentEipIdList,
        type: 'associate',
      };
      Ajax.put('/api/cps/nat/operateBind', params, {
        headers: {
              'Content-Type': 'application/json'
            }
      })
        .then((res) => {
           this.$message.success(this.$t('privateNetInstance.operateSuccess'));
        })
        .catch(async (err) => {
          const { response } = err.data;
          try {
            const json = await response.json();
            this.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally(() => {
          this.handleClose();
          this.$emit('refresh');
          // 延迟重置loading状态，确保弹窗完全关闭后再重置
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    optionalSelectionChange(val) {
      const difference = this.flexPublicNetList.filter(v => !val.includes(v)).map((item) => {
        item.flag = false;
        return item;
      });
      this.currentAddList = val.map((item) => {
        item.flag = true;
        return item;
      }); 
      this.currentEipIdList = this.currentAddList.map(item => item.elasticIpId);
      if (this.currentAddList.length >= (20 - this.rowInfo.eipNum)) {
        this.currentHover = true;
      } else {
        this.currentHover = false;
      }
    },
    getFlexPublicNetList() {
      const params = {
        region: this.region,
        status: 'disassociate',
        pageSize: 1000
      };
      Ajax.get('/api/cps/listElasticIps', params)
        .then((res) => {
          this.flexPublicNetList = res.data.elasticIps.filter(item => (item.status !== 'associate') && (item.charge.chargeStatus === 'normal'));
        })
        .catch(async (err) => {
          const { response } = err.data;
          try {
            const json = await response.json();
            target.$message.error(json.errmsg);
          } catch (ex) {
            console.log(ex);
          }
        })
        .finally();
    },
  },
};
</script>

<style lang="scss">
  .bind-dialog {
    .el-alert {
      padding: 5px 8px;
      margin: 0 0 20px;
      .el-alert__title {
        word-break: break-all !important;
      }
    }

    .el-alert--info {
      background-color: #fff4e5;
      border-color: #ff9600;
      color: #ff9600;
    }

    .bind-flex-net {
      .el-radio {
        .el-radio__label {
          padding-left: 0;
        }
      }
    }

    .is-leaf{
      .cell {
        .el-checkbox {
            display: none;
                }
            }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/nat/BindEip.vue